import type { TabletopCanvasInputState } from "../controls/TabletopCanvasInputContext";

import { ReactElement, useState } from "react";
import Flexbox from "../../../common/components/layout/Flexbox/Flexbox";
import TabletopCanvas from "./TabletopCanvas";
import TabletopEditorToolbar from "./TabletopEditorToolbar";
import TabletopHexGrid from "../objects/grid/TabletopHexGrid";
import TabletopUniverse from "../objects/TabletopUniverse";
import TabletopViewport from "../objects/TabletopViewport";
import {
    DefaultCanvasInputState,
    TabletopCanvasInputContext,
} from "../controls/TabletopCanvasInputContext";

import "./TabletopWorkspace_style.css";

const canvasDimensions = { width: 800, height: 600 };

const tabletopViewport = new TabletopViewport({
    x: -canvasDimensions.width / 2,
    y: -canvasDimensions.height / 2,
    width: canvasDimensions.width,
    height: canvasDimensions.height,
});

const tabletopUniverse = new TabletopUniverse();
const grid: TabletopHexGrid = new TabletopHexGrid(tabletopUniverse.unitLength);
tabletopUniverse.addElement(grid);

export default function TabletopWorkspace(): ReactElement {
    const [canvasInputState, setCanvasInputState] =
        useState<TabletopCanvasInputState>(DefaultCanvasInputState);

    return (
        <TabletopCanvasInputContext.Provider
            value={{
                state: canvasInputState,
                setState: setCanvasInputState,
            }}
        >
            <Flexbox direction="row" gap={8}>
                <div className="tabletop-workspace">
                    <TabletopCanvas
                        className="workspace-canvas"
                        width={canvasDimensions.width}
                        height={canvasDimensions.height}
                        universe={tabletopUniverse}
                        viewport={tabletopViewport}
                    />
                    <TabletopEditorToolbar
                        className="workspace-toolbar"
                        style={{
                            width: canvasDimensions.width,
                            height: canvasDimensions.height,
                        }}
                    />
                </div>
            </Flexbox>
        </TabletopCanvasInputContext.Provider>
    );
}
